import React, { useEffect, useState } from "react";
import PageTableHeader from "../../../../components/pageTableHeader/pageTableHeader";
import { Bar, Line } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import toast from "react-hot-toast";
import { academicReport } from "../../../../../services/workspace/report.service";

// Register the Chart.js components
ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend
);

const items = [
  { label: "Home", path: "/" },
  { label: "Reports", path: "/reports" },
  { label: "Academic Reports" },
];

const AcademicReports = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [chartData, setChartData] = useState(null);

  const fetchData = async () => {
    setIsLoading(true);
    try {
      const response = await academicReport({});

      if (response) {
        const datasets = [];
        if (response?.previous_session) {
          datasets.push({
            label: "Previous Session",
            data: [
              response?.previous_session?.total_student_leads || 0,
              response?.previous_session?.total_admitted_students || 0,
              response?.previous_session?.total_not_admitted_students || 0,
            ],
            borderColor: "rgba(75, 192, 192, 1)",
            backgroundColor: "rgba(75, 192, 192, 0.2)",
            tension: 0.4,
          });
        }
        if (response?.current_session) {
          datasets.push({
            label: "Current Session",
            data: [
              response?.current_session?.total_student_leads || 0,
              response?.current_session?.total_admitted_students || 0,
              response?.current_session?.total_not_admitted_students || 0,
            ],
            borderColor: "rgba(153, 102, 255, 1)",
            backgroundColor: "rgba(153, 102, 255, 0.2)",
            tension: 0.4,
          });
        }
        setChartData({
          labels: ["Total Leads", "Admitted", "Not Admitted"],
          datasets: datasets,
        });
      }
    } catch (error) {
      toast.error("Failed to fetch data");
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  

  return (
    <div className="flex flex-col shadow-md">
      <PageTableHeader breadcrumbs={items} isSearch={false} isFilter={false} />
      <div className="flex flex-col gap-2">
        {chartData && (
          <Line
            data={chartData}
            options={{
              responsive: true,
              plugins: {
                legend: { position: "top" },
                title: { display: true, text: "Academic Reports Overview" },
              },
            }}
          />
        )}
      </div>
    </div>
  );
};

export default AcademicReports;
